import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';

export default function Terms() {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-bold mb-4 text-primary-text">{t('terms.pageTitle')}</h1>
          <p className="text-secondary-text text-lg">{t('terms.effectiveDateLabel')} 07 / 06 / 2025</p>
          <p className="text-secondary-text text-lg">{t('terms.lastUpdatedLabel')} 18 / 06 / 2025</p>
        </header>

        <div className="space-y-8">
          {/* Welcome */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6 space-y-4">
              <p className="text-secondary-text">{t('terms.intro.p1')}</p>
              <p className="text-secondary-text">{t('terms.intro.p2')}</p>
            </div>
          </section>

          {/* 1. Acceptance of Terms */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s1.title')}</h2>
              <p className="mt-2 text-secondary-text">{t('terms.s1.intro')}</p>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s1.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s1.li2')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s1.li3')}</span></li>
              </ul>
            </div>
          </section>

          {/* 2. Services Provided */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s2.title')}</h2>
              <h4 className="mt-2 text-primary-text">{t('terms.s2.introTitle')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s2.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s2.li2')}</span></li>
              </ul>
              <p className="text-secondary-text">{t('terms.s2.note')}</p>
            </div>
          </section>

          {/* 3. User Registration */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s3.title')}</h2>
              <p className="text-secondary-text">{t('terms.s3.intro')}</p>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s3.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s3.li2')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s3.li3')}</span></li>
              </ul>
              <p className="text-secondary-text">{t('terms.s3.note')}</p>
            </div>
          </section>

          {/* 4. User Responsibilities */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s4.title')}</h2>
              <h4 className="text-primary-text">{t('terms.s4.responsibleTitle')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s4.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s4.li2')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s4.li3')}</span></li>
              </ul>
              <h4 className="text-primary-text">{t('terms.s4.prohibitedTitle')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s4.li4')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s4.li5')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s4.li6')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s4.li7')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s4.li8')}</span></li>
              </ul>
            </div>
          </section>

          {/* 5. Platform Fees */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s5.title')}</h2>
              <p className="text-secondary-text">{t('terms.s5.p1')}</p>
              <h4 className="mt-4 text-primary-text">{t('terms.s5.currencyTitle')}</h4>
              <p className="text-secondary-text">{t('terms.s5.p2')}</p>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s5.currency.sek')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s5.currency.dkk')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s5.currency.nok')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s5.currency.eur')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s5.currency.isk')}</span></li>
              </ul>
              <p className="text-secondary-text">{t('terms.s5.p3')}</p>
              <h4 className="mt-4 text-primary-text">{t('terms.s5.taxesTitle')}</h4>
              <p className="text-secondary-text">{t('terms.s5.p4')}</p>
            </div>
          </section>

          {/* 6. Contracts Between Users */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s6.title')}</h2>
              <p className="text-secondary-text">{t('terms.s6.p1')}</p>
              <h4 className="text-primary-text">{t('terms.s6.header')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s6.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s6.li2')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s6.li3')}</span></li>
              </ul>
              <p className="text-secondary-text">{t('terms.s6.p2')}</p>
            </div>
          </section>

          {/* 7. Payment Terms */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s7.title')}</h2>
              <h4 className="text-primary-text">{t('terms.s7.header')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s7.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s7.li2')}</span></li>
              </ul>
              <p className="text-secondary-text">{t('terms.s7.p')}</p>
            </div>
          </section>

          {/* 8. Content and Intellectual Property */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s8.title')}</h2>
              <p className="text-secondary-text">{t('terms.s8.p1')}</p>
              <h4 className="text-primary-text">{t('terms.s8.header')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s8.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s8.li2')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s8.li3')}</span></li>
              </ul>
            </div>
          </section>

          {/* 9. Privacy and Data Protection */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s9.title')}</h2>
              <p className="text-secondary-text">{t('terms.s9.p1')}</p>
              <p className="text-secondary-text">{t('terms.s9.p2')}</p>
            </div>
          </section>

          {/* 10. Account Termination */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s10.title')}</h2>
              <h4 className="text-primary-text">{t('terms.s10.header')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s10.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s10.li2')}</span></li>
              </ul>
              <p className="text-secondary-text">{t('terms.s10.p')}</p>
            </div>
          </section>

          {/* 11. Liability Disclaimer */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s11.title')}</h2>
              <h4 className="text-primary-text">{t('terms.s11.header')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s11.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s11.li2')}</span></li>
              </ul>
              <p className="text-secondary-text">{t('terms.s11.p')}</p>
            </div>
          </section>

          {/* 12. Governing Law and Jurisdiction */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s12.title')}</h2>
              <p className="text-secondary-text">{t('terms.s12.p1')}</p>
              <h4 className="text-primary-text">{t('terms.s12.header')}</h4>
              <ul className="pl-1 space-y-2 my-4 text-secondary-text">
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s12.li1')}</span></li>
                <li className="flex items-start gap-3"><Sparkles className="w-4 h-4 mt-1 text-primary-text flex-shrink-0" aria-hidden="true" /><span>{t('terms.s12.li2')}</span></li>
              </ul>
            </div>
          </section>

          {/* 13. Changes to Terms */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s13.title')}</h2>
              <p className="text-secondary-text">{t('terms.s13.p1')}</p>
            </div>
          </section>

          {/* 14. Contact Information */}
          <section className="rounded-lg border border-zinc-200 dark:border-zinc-800 section-bg shadow-sm card-hover">
            <div className="p-6">
              <h2 className="text-xl font-semibold text-primary-text">{t('terms.s14.title')}</h2>
              <p className="text-secondary-text">{t('terms.s14.p1')}</p>
              <p className="text-secondary-text">{t('terms.s14.email')}</p>
              <p className="text-secondary-text">{t('terms.s14.company')}</p>
              <p className="text-secondary-text">{t('terms.s14.address')}</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}